// MSAL ssoSilent creates a hidden iframe that navigates to this origin — the
// PARENT frame reads the iframe's URL directly (SilentIframeClient.monitorIframeForHash),
// nothing needs to execute inside the iframe itself. This used to be a guard
// AFTER all of bootstrap.ts's imports (Vue, Highcharts + 11 modules, Sentry,
// the whole App.vue tree, router, ~2.9MB eagerly evaluated) — but ES module
// static imports are hoisted and always run before any in-file check, guard
// or not. So every ssoSilent call (every reactive session recovery in
// services/auth/session.ts, every proactive renewal check in
// services/auth/proactive-renewal.ts) fully imported and evaluated the whole
// app bundle inside the invisible iframe — real CPU cost, not just network
// waiting.
//
// Fix: this file is now a two-line shim. bootstrap.ts is the entire previous
// content of this file, UNCHANGED (same static imports, same order — no
// hand-reordering, no ordering risk for Highcharts' registration-order
// dependencies). It's only ever imported when window === window.top, so the
// iframe now does none of that work. This does NOT touch redirectUri and
// does not add any new page — index.html's #app-splash is plain inline
// HTML/CSS unaffected by this, and bootstrap.ts still fades it out exactly
// as before. A prior fix attempt using a dedicated blank MSAL redirect page
// was already tried and reverted (stayed visibly blank too long) — this is
// a different mechanism and doesn't reintroduce that.
if (window === window.top) {
  void import('./bootstrap');
}
// else: do nothing — parent's SilentIframeClient.monitorIframeForHash handles auth.
